import { Modal, Table } from 'antd';
import LocaleContext from 'locales';
import moment from 'moment';
import React, { useContext, useEffect } from 'react';
import { getConnHistory } from 'services/websocket/auth';

/**
 * VD 접속 기록 테이블
 * @param {boolean} visible modal visible
 * @param {function} dispatch handler modal visible
 * @param {object[]} dataSource
 * @returns ReactNode
 */
function ConnHistoryTable({ visible, dispatch, current }) {
  const { locale } = useContext(LocaleContext);
  const onClose = () => dispatch({ type: 'set-visibleConnHistory', payload: false });
  const [dataSource, setDataSource] = React.useState([]);
  const [pagingParams, setPagingParams] = React.useState({ current: 1, pageSize: 10 });
  useEffect(() => {
    if (visible) {
      getConnHistory(current, pagingParams).then((res) => {
        setDataSource(res.data);
        setPagingParams((prev) => ({
          ...prev,
          total: res.total,
        }));
      });
      return;
    }
    setDataSource([]);
    setPagingParams({ current: 1, pageSize: 10 });
  }, [visible, pagingParams.current]);

  return (
    <Modal
      title={locale.resource['txt.last-connection-history']}
      visible={visible}
      width={840}
      onOk={onClose}
      onCancel={onClose}
      cancelButtonProps={{ style: { display: 'none' } }}
      destroyOnClose
    >
      <Table
        size="small"
        rowKey="sessionId"
        dataSource={dataSource}
        pagination={{
          showSizeChanger: false,
          defaultPageSize: 10,
          total: pagingParams.total || 0,
          onChange: (page, pageSize) => {
            setPagingParams({ current: page, pageSize });
          },
        }}
        columns={[
          {
            title: locale.resource['txt.connected-date'],
            dataIndex: 'loginDate',
            width: 140,
            render: (text) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
          },
          {
            title: locale.resource['txt.disconnected-date'],
            dataIndex: 'logoutDate',
            width: 140,
            render: (text, record) =>
              record.logoutDate ? moment(text).format('YYYY-MM-DD HH:mm:ss') : null,
          },
          { title: locale.resource['txt.adAccount'], dataIndex: 'adAccount' },
          { title: locale.resource['txt.vdId'], dataIndex: 'vdId', width: 268 },
          { title: locale.resource['txt.source-ip'], dataIndex: 'ip' },
        ]}
      />
    </Modal>
  );
}

export default ConnHistoryTable;
